import { Injectable } from '@angular/core';
import { CatalogsService } from '@app/core/services/catalogs.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, mergeMap, switchMap } from 'rxjs/operators';

import * as fromActions from '@app/manage-sets/store/quicklinks-sets-table/quicklinks-sets-table.actions';
import * as fromReducer from '@app/manage-sets/store/quicklinks-sets-table/quicklinks-sets-table.reducer';
import * as fromSelectors from '@app/manage-sets/store/quicklinks-sets-table/quicklinks-sets-table.selectors';

import { QuicklinksSet } from '@app/core/models';
import { QuicklinksSetService } from '@app/core/services/quicklinks-set.service';
import { WorkdayService } from '@app/core/services/workday.service';

@Injectable()
export class QuicklinksSetsTableEffects {

  
public initTable$ = createEffect(() =>
this.actions$.pipe(
  ofType(fromActions.initTable),
  switchMap(() => this.store$.pipe(
      select(fromSelectors.selectTableRequestData),
      debounceTime(50),
      distinctUntilChanged((prev, next) => {
        if (prev.resetIndex && !next.resetIndex) {
          delete prev.resetIndex
          delete next.resetIndex
        }
        return JSON.stringify(prev) === JSON.stringify(next)
      }),
      map(({filters, pageIndex, pageSize, sort, resetIndex}) => ({
        filters, 
        sort,
        pageIndex: resetIndex ? 0 : pageIndex,
        pageSize
      }))
    )
  ),
  map((requestData) => fromActions.getTableRequest(requestData))
), { dispatch: true}
);
public getTableRequest$ = createEffect(() =>
this.actions$.pipe(
  ofType(fromActions.getTableRequest),
  switchMap((requestData) => this.quicklinksSetService.putFilterQuicklinksSet(requestData).pipe(
    map(res => ({
      data: res.data as Array<QuicklinksSet>, pagination: res.pagination
    }))
  )),
  map(({data, pagination}) => fromActions.getTableSuccess({data, pagination})),
  catchError(({ message }) => of(fromActions.getTableFailure({ error: message })))

), { dispatch: true}
);
  
public deleteQuicklinksSetRequest$ = createEffect(() =>
this.actions$.pipe(
  ofType(fromActions.deleteQuicklinksSetRequest),
  mergeMap(({id}) =>
    this.quicklinksSetService.deleteQuicklinksSet(id).pipe(
      mergeMap(() => [
        fromActions.deleteQuicklinksSetSuccess(),
      ]),
      catchError(({ message }) => of(fromActions.deleteQuicklinksSetFailure({error: message })))
    )
  )
), { dispatch: true }
);

  constructor(
    private actions$: Actions,
    private store$: Store<fromReducer.State>,
    private catalogsService: CatalogsService,
    private quicklinksSetService: QuicklinksSetService,
    private workdayService: WorkdayService
  ) {}

}
